var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPreopIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#A7A7A7;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "",
    transform: "translate(-60.000000, -1519.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "translate(56.000000, 160.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "file_x5F_text_x5F_data-_x5B__x23_1701_x5D_",
    className: "st0",
    d: "M402.5,1732.8c0,13.7-11.1,24.8-24.8,24.8H130.3 c-13.7,0-24.8-11.1-24.8-24.8s11.1-24.8,24.8-24.8h247.5C391.4,1708,402.5,1719.1,402.5,1732.8L402.5,1732.8z M130.3,1609h247.5 c13.7,0,24.8,11.1,24.8,24.8s-11.1,24.8-24.8,24.8H130.3c-13.7,0-24.8-11.1-24.8-24.8S116.6,1609,130.3,1609L130.3,1609z  M105.5,1534.8v-49.5c0-13.7,11.1-24.8,24.8-24.8h99c13.7,0,24.8,11.1,24.8,24.8v49.5c0,13.7-11.1,24.8-24.8,24.8h-99 C116.6,1559.5,105.5,1548.4,105.5,1534.8L105.5,1534.8z M452,1782.3c0,13.7-11.1,24.8-24.8,24.8H80.8 c-13.7,0-24.8-11.1-24.8-24.8v-346.5c0-13.7,11.1-24.8,24.8-24.8h222.8v99c0,27.3,22.2,49.5,49.5,49.5h99V1782.3z M494.2,1502.7 l-134-134c-4.7-4.7-10.9-7.3-17.5-7.3H56c-27.3,0-49.5,22.2-49.5,49.5v396c0,27.3,22.2,49.5,49.5,49.5h396 c27.3,0,49.5-22.2,49.5-49.5v-286.8C501.5,1513.7,498.9,1507.4,494.2,1502.7L494.2,1502.7z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreopIcon);
export default __webpack_public_path__ + "static/media/preop_icon.3c3afb962a11543d3bb539bc52e7c452.svg";
export { ForwardRef as ReactComponent };